<template>
  <div
    class="button"
    :class="{disabled : disabled}"
    @click="emitClick">
    <span v-if="loading">
      <Icon
        class="btn-icon center"
        name="loadingCircle"
        size="20" />
    </span>
    <span v-else>
    <Icon
      v-if="icon"
      class="btn-icon"
      :class="position"
      :name="icon.name"
      :size="icon.size" />
    <span class="button-text">{{ btnText }}</span>
    </span>
  </div>
</template>

<script>

export default {
  name: 'Button',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    btnText: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: 'icon-pos-left'
    },
    icon: {
      type: Object,
    },
  },
  methods: {
    emitClick() {
      if (!this.disabled) {
        this.$emit('btnClick');
      }
    },
  },
}
</script>
